import React from 'react';

import { useLoadBrief, useCreateBrief, useUpdateBrief } from '../../data';
import BriefForm from './BriefForm';
import { NAME } from './constants';

export const BriefFormCreate = ({ onSubmit, onClose, onExited, open }) => {
  const [createBrief, { isLoading: isCreating }] = useCreateBrief();

  const handleSubmit = async (values = {}) => {
    const createdBrief = await createBrief(values);
    onSubmit(createdBrief);
  };

  return (
    <BriefForm
      title={'Add Brief'}
      loading={isCreating}
      onClose={onClose}
      onExited={onExited}
      open={open}
      initialValues={{}}
      onSubmit={handleSubmit}
    />
  );
};

export const BriefFormEdit = ({ id, onClose, onSubmit, onExited, open }) => {
  const { data, isLoading } = useLoadBrief(id);
  const [updateBrief, { isLoading: isUpdating }] = useUpdateBrief();

  const handleSubmit = async (values) => {
    const response = await updateBrief(values);
    onSubmit(response);
  };

  return (
    <BriefForm
      title={'Edit Brief'}
      subTitle={data?.[NAME]}
      entityId={id}
      loading={isLoading || isUpdating}
      onClose={onClose}
      onExited={onExited}
      open={open}
      initialValues={data}
      active={!!data}
      onSubmit={handleSubmit}
    />
  );
};

export const BriefFormDuplicate = ({
  id,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const { data, isLoading } = useLoadBrief(id, {
    select: ({ id: _omittedId, name: _omittedName, ...other }) => other,
  });
  const [createBrief, { isLoading: isCreating }] = useCreateBrief();

  const handleSubmit = async (values = {}) => {
    const createdBrief = await createBrief(values);
    onSubmit(createdBrief);
  };

  return (
    <BriefForm
      title={'Add Brief'}
      loading={isLoading || isCreating}
      onClose={onClose}
      initialValues={data}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
    />
  );
};
